import { Component, For, Show } from "solid-js";
import { getDisplayId } from "../../utils/displayId";

export interface ParentBreadcrumbSegment {
  id: string;
  itemNumber?: number;
  title: string;
}

export interface ParentBreadcrumbProps {
  segments: ParentBreadcrumbSegment[];
  prefix: string;
}

export const ParentBreadcrumb: Component<ParentBreadcrumbProps> = (props) => (
  <Show when={props.segments.length > 0}>
    <nav
      aria-label="Hierarchy"
      class="flex items-center gap-1 text-sm text-ink-3 min-w-0"
    >
      <For each={props.segments}>
        {(seg, i) => {
          const displayId = getDisplayId(props.prefix, seg.id, seg.itemNumber);
          return (
            <>
              <Show when={i() > 0}>
                <span aria-hidden="true" class="font-mono text-line-strong">
                  ›
                </span>
              </Show>
              <a
                href={`/items/${seg.id}`}
                class="inline-flex items-center gap-1 max-w-[20ch] hover:text-ink hover:underline underline-offset-2 rounded-sm focus-ring hit-area"
                title={`${displayId} — ${seg.title}`}
              >
                <span class="font-mono text-xs tabular-nums text-ink-2 whitespace-nowrap">
                  {displayId}
                </span>
                <span class="truncate">{seg.title}</span>
              </a>
            </>
          );
        }}
      </For>
    </nav>
  </Show>
);
